"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _enums = require("MeetingsBase/constants/enums");

var _CustomHostedDomain = _interopRequireDefault(require("MeetingsBase/models/CustomHostedDomain"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var defaults = {
  calendarAccountId: null,
  portalId: null,
  branding: _Branding.default.from(),
  id: null,
  userId: null,
  namespace: null,
  calendarIntegrationChoice: _enums.CAL_INTEGRATIONS.GOOGLE,
  calendarEmail: null,
  calendarIdToWriteTo: null,
  calendarIdsToCheck: (0, _immutable.Map)(),
  calendarDisplayNames: (0, _immutable.Map)(),
  ewsUri: null,
  calendarUsername: null,
  unavailableCalendarIds: (0, _immutable.List)(),
  userProfile: _UserProfile.default.from({}),
  defaultLinkId: null,
  isSalesStarter: false,
  customHostedDomain: null,
  isOnboarded: true
};

var MeetingsUser =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(MeetingsUser, _Record);

  function MeetingsUser() {
    (0, _classCallCheck2.default)(this, MeetingsUser);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MeetingsUser).apply(this, arguments));
  }

  (0, _createClass2.default)(MeetingsUser, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        meetingsUserBlob: {
          calendarSettings: {
            provider: this.get('calendarIntegrationChoice'),
            email: this.get('calendarEmail'),
            calendarAccountId: this.get('calendarAccountId'),
            calendarIdToWriteTo: this.get('calendarIdToWriteTo'),
            calendarIdsToCheck: this.get('calendarIdsToCheck').toJS(),
            calendarDisplayNames: this.get('calendarDisplayNames').toJS(),
            ewsUri: this.get('ewsUri'),
            username: this.get('calendarUsername')
          }
        },
        namespace: this.get('namespace')
      };
    }
  }, {
    key: "setUnavailableCalendarIds",
    value: function setUnavailableCalendarIds(calendarVerification) {
      var calendarVerificationForOwner = calendarVerification.get(this.get('calendarEmail'));
      var unavailableCalendarIds = calendarVerificationForOwner ? calendarVerificationForOwner.get('failedCalendarErrors').keySeq().toList() : (0, _immutable.List)();
      return this.set('unavailableCalendarIds', unavailableCalendarIds);
    }
  }], [{
    key: "from",
    value: function from(json) {
      var calendarIdsToCheck = {};

      if (json.meetingsUserBlob.calendarSettings.calendarIdsToCheck) {
        var _json$meetingsUserBlo = json.meetingsUserBlob.calendarSettings.calendarIdsToCheck,
            primary = _json$meetingsUserBlo.primary,
            rest = (0, _objectWithoutProperties2.default)(_json$meetingsUserBlo, ["primary"]);
        calendarIdsToCheck = rest;
      }

      return new MeetingsUser({
        portalId: json.portalId,
        branding: _Branding.default.from(json.meetingsUserBlob.brandSettings),
        id: json.id,
        userId: json.userId,
        namespace: json.namespace,
        userProfile: _UserProfile.default.from(json.userProfile),
        calendarAccountId: json.meetingsUserBlob.calendarSettings.calendarAccountId,
        calendarIntegrationChoice: json.meetingsUserBlob.calendarSettings.provider,
        calendarEmail: json.meetingsUserBlob.calendarSettings.email,
        calendarIdToWriteTo: json.meetingsUserBlob.calendarSettings.calendarIdToWriteTo || null,
        calendarIdsToCheck: (0, _immutable.Map)(calendarIdsToCheck),
        calendarDisplayNames: (0, _immutable.Map)(json.meetingsUserBlob.calendarSettings.calendarDisplayNames),
        ewsUri: json.meetingsUserBlob.calendarSettings.ewsUri,
        calendarUsername: json.meetingsUserBlob.calendarSettings.username,
        isSalesStarter: json.hasSalesStarterFeatures || json.isSalesStarter || json.salesPro || false,
        customHostedDomain: _CustomHostedDomain.default.from(json.customHostedDomain),
        isOnboarded: json.isOnboarded
      });
    }
  }]);
  return MeetingsUser;
}((0, _immutable.Record)(defaults));

exports.default = MeetingsUser;
module.exports = exports.default;